import get from 'lodash/get';
import React from 'react'
import { useTranslation } from 'react-i18next';
import HistoryBlock, { processHistory } from './HistoryBlock';

const HistoryLocationAuthorization = ({device}) => {
  const { t } = useTranslation();

  return (
    <HistoryBlock
      title={t("devices.LocationStatusHistory")}
      data={
        processHistory("location_status")(get(device, 'history.location_status'))}
      cloumnTitle="location status"
      cloumnAccessor={"location_status"}
    />
   );
}

export default HistoryLocationAuthorization;